import { render, staticRenderFns } from "./updateFile.vue?vue&type=template&id=1780a128&scoped=true&"
import script from "./updateFile.vue?vue&type=script&lang=js&"
export * from "./updateFile.vue?vue&type=script&lang=js&"
import style0 from "./updateFile.vue?vue&type=style&index=0&id=1780a128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780a128",
  null
  
)

export default component.exports